import { render, staticRenderFns } from "./MostUsedMedicinesAll.vue?vue&type=template&id=4645d146&scoped=true&"
import script from "./MostUsedMedicinesAll.vue?vue&type=script&lang=js&"
export * from "./MostUsedMedicinesAll.vue?vue&type=script&lang=js&"
import style0 from "./MostUsedMedicinesAll.vue?vue&type=style&index=0&id=4645d146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4645d146",
  null
  
)

export default component.exports